import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isSupabaseConfigured, supabase } from '@/lib/supabase';

interface AuthGuardProps {
  children: React.ReactNode;
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('donnos_admin_auth') === 'true');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function checkAuth() {
      const localAuth = localStorage.getItem('donnos_admin_auth') === 'true';
      if (isSupabaseConfigured && supabase) {
        const { data } = await supabase.auth.getSession();
        const supabaseAuth = Boolean(data.session);
        if (mounted) {
          setIsAuthenticated(localAuth || supabaseAuth);
          setChecking(false);
          if (!localAuth && !supabaseAuth && location.pathname !== '/admin/login') {
            navigate('/admin/login', { replace: true });
          }
        }
        return;
      }

      if (mounted) {
        setIsAuthenticated(localAuth);
        setChecking(false);
        if (!localAuth && location.pathname !== '/admin/login') {
          navigate('/admin/login', { replace: true });
        }
      }
    }

    checkAuth();

    return () => {
      mounted = false;
    };
  }, [navigate, location.pathname]);

  if (checking || !isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
